module.exports = __webpack_public_path__ + "static/media/invite.e7faf110.jpg";